module.exports = __webpack_public_path__ + "img/contentful.b734d5e1.svg";